import Widget from 'models/dashboard/widget'

Widget.WelcomeWidget = Widget.extend({
});

export default Widget.WelcomeWidget;

